// Ask this folder (release 6.1: no page keeps its own answer area): the question opens the one assistant drawer, looking
// at this folder, where the answer comes from its files with the file and page. The suggested questions go there too.
import type { FileItem } from '@dpw/shared';
import { useAssistantPanel } from '../assistant/Panel';

export function useAsk(folder: { id: string; name: string }) {
  const panel = useAssistantPanel();
  const ask = (q: string) => {
    const question = q.trim();
    if (question.length < 2) return;
    panel.open({ folderId: folder.id, label: folder.name, prompt: question, send: true });
  };
  return { ask };
}

/** "What is in this folder?", then a question about each of the two files changed most recently. */
export function chipsFor(files: FileItem[]): string[] {
  const named = files.filter(f => f.status === 'ready' && f.summaryLine).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 2)
    .map(f => `What does ${f.name.replace(/\.[a-z0-9]+$/i, '')} say?`);
  return ['What is in this folder?', ...named];
}
